import axios from 'axios';

export const getDailyDigest = async (options = {}) => {
    const params = {};
    if (options.days) params.days = options.days;
    const { data } = await axios.get('/api/daily-digest', { params });
    return data;
};

export const getDailyDigestSection = async ({ section, ...options }) => {
    if (!section) throw new Error('section is required');
    const params = {};
    if (options.days) params.days = options.days;
    if (options.startDate) params.startDate = options.startDate;
    if (options.endDate) params.endDate = options.endDate;
    if (options.programName) params.programName = options.programName;
    if (options.bac) params.bac = options.bac;
    if (options.rowKey) params.rowKey = options.rowKey;
    if (options.search) params.search = options.search;
    if (options.level) params.level = options.level;
    if (options.limit) params.limit = options.limit;
    if (options.offset !== undefined) params.offset = options.offset;
    const { data } = await axios.get(`/api/daily-digest/sections/${encodeURIComponent(section)}`, { params });
    return data;
};
